/* [ELICO 2026-10-07] Carousel behaviour for sections/elico-pdp-carousel.liquid (data-epc-*).
   Native horizontal scroll-snap track; Previous/Next scroll by one slide; counter "i / n" and a
   progress bar follow the scroll position. Several carousels per page are independent. */
(function () {
  'use strict';
  function init(c) {
    if (c.getAttribute('data-epc-ready')) return;
    c.setAttribute('data-epc-ready', '1');
    var trk = c.querySelector('[data-epc-track]');
    if (!trk) return;
    var sl = Array.prototype.slice.call(trk.children);
    var bar = c.querySelector('[data-epc-bar]');
    var cnt = c.querySelector('[data-epc-count]');
    var pv = c.querySelector('[data-epc-prev]');
    var nx = c.querySelector('[data-epc-next]');
    var pad = function () { return parseFloat(getComputedStyle(trk).paddingLeft) || 0; };
    function idx() {
      var b = 0, d = 1e9;
      sl.forEach(function (s, i) {
        var x = Math.abs(s.offsetLeft - trk.offsetLeft - pad() - trk.scrollLeft);
        if (x < d) { d = x; b = i; }
      });
      return b;
    }
    // scroll positions = slides minus the ones visible at once, so the counter steps 1..pages
    // without jumping to n on the last scroll (several slides per view on desktop)
    function pages() {
      if (sl.length < 2) return sl.length;
      var step = sl[1].offsetLeft - sl[0].offsetLeft;
      var per = step > 0 ? Math.max(1, Math.floor((trk.clientWidth - pad() + 4) / step)) : 1;
      return Math.max(1, sl.length - per + 1);
    }
    function upd() {
      var n = pages();
      var i = trk.scrollLeft + trk.clientWidth >= trk.scrollWidth - 4 ? n - 1 : Math.min(idx(), n - 1);
      if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
      if (bar) { bar.style.width = (100 / n) + '%'; bar.style.left = (i * 100 / n) + '%'; }
      if (pv) pv.disabled = trk.scrollLeft <= 2;
      if (nx) nx.disabled = trk.scrollLeft + trk.clientWidth >= trk.scrollWidth - 4;
      // everything fits (e.g. 3 steps in a 3-up desktop track): hide progress + controls
      c.classList.toggle('epc--fits', trk.scrollWidth <= trk.clientWidth + 4);
    }
    function go(i) {
      i = Math.max(0, Math.min(sl.length - 1, i));
      trk.scrollTo({ left: sl[i].offsetLeft - trk.offsetLeft - pad(), behavior: 'smooth' });
    }
    if (pv) pv.addEventListener('click', function () { go(idx() - 1); });
    if (nx) nx.addEventListener('click', function () { go(idx() + 1); });
    trk.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    trk.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(idx() + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(idx() - 1); e.preventDefault(); }
    });
    window.addEventListener('resize', upd);
    upd();
  }
  function boot() { document.querySelectorAll('[data-epc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
